<div class="counter" [class.disabled]="disabled()">
  <span [class.disabled]="disabledDecrease()" (click)="onDec()">-</span>
  {{ value() }}
  <span [class.diabled]="disabledIncrease()" (click)="onInc()">+</span>
</div>
